// src/zustand/userStore.ts
import { axiosRequest } from '../network/axiosInstance'
export const useWhoAmi = axiosRequest({ method: 'GET', url: 'api/whoami' }, {})

/* Projects data format
{"userId":"66210d28fd1690725869ffb0",
 "userName":"Jouni Miikki",
"userEmail":"jouni.miikki@overscalesolutions.com" }
*/

/* export const useGetUsers = request({
    method: "GET",
    url: "https://jsonplaceholder.typicode.com/users",
  });

  export const useGetSingleUser = request({
    method: "GET",
    url: "https://jsonplaceholder.typicode.com/users/",
  });

  export const useEditUser = request(
    {
      method: "PUT",
      url: "https://jsonplaceholder.typicode.com/users/",
    },
    {
      onSuccess: () => {
        useGetUsers.getState().execute({ force: true });
      },
    }
  ); */
